<template>
  <vx-card class="editor-left-bar items-center">
    <vx-tooltip text="Editor" position="right">
      <div class="vs-sidebar--item cursor-pointer" v-if="organization">
        <div class="getboarded-logo mb-base">
          <a href="https://getboarded.com/user/dashboard" target="_blank">
            <img :src="organizationLogo" />
          </a>
        </div>
      </div>
      <div class="vs-sidebar--item cursor-pointer" v-else>
        <div class="getboarded-logo mb-base">
          <a href="https://getboarded.com/user/dashboard" target="_blank">
            <img :src="organizationLogo" />
          </a>
        </div>
      </div>
    </vx-tooltip>
    <div v-for="(et, index) in editorTabs" :key="index">
      <vx-tooltip
        v-if="editorTabs[index].active"
        :text="
          organizationSlug === 'gala' && editorTabs[index].name === 'abilities'
            ? 'Abilities'
            : $t(`editor.${editorTabs[index].name}.title`)
        "
        position="right"
      >
        <div
          :id="index === 'personality' ? 'v-step-4' : ''"
          class="vs-sidebar--item"
          :class="{
            'vs-sidebar-item-active':
              (routeName === `editor-${index}` ||
                routeName === `editor-${index}-custom`) &&
              index != 'personality',
          }"
        >
          <!-- <router-link :to="organizationSlug === 'default' ? {name: `editor-${index}`} : {name: `editor-${index}-custom`}" class="editor-icon">
            <img
              v-if="routeName === `editor-${index}` || routeName === `editor-${index}-custom`"
              :src="require(`@/assets/images/icons/editor-icons/active/${index}.svg`)"
            />
            <img
              v-else
              :src="require(`@/assets/images/icons/editor-icons/inactive/${index}.svg`)"
            />
          </router-link> -->
          <router-link
            v-if="organizationSlug === 'gala'"
            :to="{ name: `editor-${index}-org` }"
            class="editor-icon"
          >
            <img
              v-if="
                routeName === `editor-${index}` ||
                routeName === `editor-${index}-org`
              "
              :src="
                require(`@/assets/images/icons/editor-icons/active/${index}.svg`)
              "
            />
            <img
              v-else
              :src="
                require(`@/assets/images/icons/editor-icons/inactive/${index}.svg`)
              "
            />
          </router-link>
          <router-link
            v-else
            :to="
              boardSlug
                ? { name: `editor-${index}-custom` }
                : { name: `editor-${index}` }
            "
            class="editor-icon"
          >
            <img
              v-if="
                routeName === `editor-${index}` ||
                routeName === `editor-${index}-custom`
              "
              :src="
                require(`@/assets/images/icons/editor-icons/active/${index}.svg`)
              "
            />
            <img
              v-else
              :src="
                require(`@/assets/images/icons/editor-icons/inactive/${index}.svg`)
              "
            />
          </router-link>
        </div>
      </vx-tooltip>
    </div>
    <span id="v-step-3"></span>
    <div class="logout--main">
      <div class="vs-sidebar--item vs-sidebar--item-logout">
        <vx-tooltip :text="$t('editor.logout.title')" position="right">
          <div @click="logout()" class="editor-logout-icon">
            <img src="@/assets/images/icons/editor-icons/logout-reverse.svg" />
          </div>
        </vx-tooltip>
      </div>
    </div>
  </vx-card>
</template>

<script>
import constants from "@/constants.js";
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  data() {
    return {
      constants,
      organizationConfig,
      organization: "",
    };
  },
  computed: {
    editorTabs() {
      return this.organizationConfig[this.organizationSlug].editorTabs;
    },
    routeName() {
      return this.$route.name;
    },
    organizationLogo() {
      return this.organizationConfig[this.organizationSlug].logo;
    },
    /*organizationId() {
      return this.$store.state.organization.orgData._id;
    },*/
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    autoLoginToken() {
      return this.$store.state.alex.data.youlabToken;
    },
    personality() {
      return this.$store.state.editor.personality;
    },
    boardSlug() {
      return this.$route.params.boardSlug;
    },
  },
  methods: {
    goToDashboard() {
      window.location.href = "/user/dashboard";
    },
    logout() {
      //TalentPaint Session Destroy For Alex
      this.$store.dispatch(
        "alex/deleteSession",
        this.$store.state.auth.user._id
      );
      //TalentPaint Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "boards/deleteSession",
        this.$store.state.auth.user._id
      );
      //Youlab Session Destroy For Gala Or Journey App
      this.$store.dispatch(
        "editor/deleteSession",
        this.$store.state.auth.user._id
      );

      this.$store.dispatch("auth/logout").then((res) => {
        if (this.organizationSlug === "default")
          window.location.href = "/about";
        else window.location.href = `/${this.organizationSlug}/about`;
      });
    },
  },
  created() {
    this.organization = this.$route.query.organization;
  },
};
</script>

<style scoped>
.vx-card {
  box-shadow: 0px 15px 55px rgba(157, 163, 180, 0.16);
}
.editor-left-bar.vx-card >>> .vx-card__collapsible-content {
  height: 100% !important;
}
.editor-left-bar.vx-card >>> .vx-card__collapsible-content .vx-card__body {
  position: relative !important;
  height: 100% !important;
}
img {
  display: block;
  margin: 0 auto;
}
.vs-sidebar--item {
  width: fit-content;
}
.vs-sidebar-item-active a {
  background: rgba(242, 147, 0, 0.1);
  border-radius: 8px;
}

.vs-sidebar--item .getboarded-logo {
  /*margin: 10px;*/
  margin-top: 0;
  /*padding: 10px;*/
  padding-top: 0;
  margin-bottom: 15px;
}

.vs-sidebar--item .getboarded-logo img {
  width: 100%;
}

/*.getboarded-logo {
  margin-bottom: 15px!important;
}*/

.vs-sidebar--item .editor-icon {
  margin: 0px;
  padding: 10px;
  margin-bottom: 10px;
}

.vs-sidebar--item-logout {
  vertical-align: bottom;
}

.logout--main {
  position: absolute;
  bottom: 1.5rem;
  left: 0;
  right: 0;
}

.vs-sidebar--item-logout .editor-logout-icon {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
}

.editor-left-bar.vx-card {
  min-width: 85px !important;
  max-width: 110px !important;
}

@media only screen and (max-width: 991px) {
  /*.editor-left-bar.vx-card {
    border-radius: 0!important;
  }*/

  .editor-left-bar.vx-card {
    min-width: auto !important;
    max-width: 110px !important;
  }

  .editor-left-bar >>> .vx-card__collapsible-content .vx-card__body {
    padding: 1.5rem 0.5rem !important;
  }

  .vs-sidebar--item .editor-icon {
    margin: 0px;
    padding: 5px;
    margin-bottom: 20px;
  }

  .vs-sidebar--item .editor-icon img {
    width: 22px;
    height: 22px;
  }

  .logout--main {
    position: initial;
  }

  .vs-sidebar--item-logout .editor-logout-icon {
    margin: 0px;
    padding: 5px;
    margin-bottom: 20px;
  }

  .vs-sidebar--item .editor-logout-icon img {
    width: 22px;
    height: 22px;
  }

  .getboarded-logo .editor-icon {
    margin: 0px;
    padding: 5px;
    margin-bottom: 20px;
  }
}
</style>
